export interface ITimer {
    seconds: number;
    secondsRemaining: number;
    runTimer: boolean;
    hasStarted: boolean;
    hasFinished: boolean;
    displayTime: string;
};


// WEBPACK FOOTER //
// ./src/app/stage/types/timer.ts